<template>
    <table class="control-table flows-table">
        <thead class="control-table__head">
            <tr class="control-table__row">
                <th style="width:80%" class="control-table__cell">
                    Name
                </th>
            </tr>
        </thead>
        <tbody class="control-table__body">
            <tr v-for="flow in flows" :key="flow.id" class="control-table__row">
                <td class="control-table__cell">
                    <div>
                        <router-link :to="{ name: 'flows-id', params: { id: flow.id } }">
                            {{ flow.label[$i18n.locale] }}
                        </router-link>
                    </div>
                    <div v-if="flow.description" class="description" style="margin-top: 0.5em;">
                        {{ flow.description[$i18n.locale] }}
                    </div>
                </td>
                <td class="control-table__cell control-table__cell--right">
                    <!-- <ActionModal
                        :method="deleteFlow"
                        action-data-field="id"
                        success-text="Flow successfuly deleted"
                        :title="'Delete flow'"
                        action-text="Delete"
                        :item="flow"
                    >
                        Are you sure you want to delete flow
                        <strong>{{ flow.label[$i18n.locale] }}</strong>
                        ?
                    </ActionModal> -->
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import { ActionModal } from '@speechki-frontend/shared/ui/modals';

import { deleteFlow } from '../../api/flows';

export default {
    name: 'FlowsTable',
    components: {
        ActionModal
    },
    props: {
        flows: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        deleteFlow
    }
};
</script>
